<div class="news-list">
  <div class="header">
    <div class="title">Новости</div>
    <a [routerLink]="getNewsListRoute()">Все</a>
  </div>
  <div class="content">
    <a [routerLink]="getNewsRoute(item.id)" class="news-item" *ngFor="let item of newsList">
      <div class="photo">
        <img [src]="item.picture.path" [alt]="item.title" [title]="item.title">
      </div>
      <div class="info">
        <div class="date">{{ item.datetime | date: 'dd.MM.yyyy, HH:mm' }}</div>
        <div class="title">{{ item.title}}</div>
      </div>
      <mtg-svg-icon icon="icons-corner-right"></mtg-svg-icon>
    </a>
  </div>
</div>
